import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {waLink} from '../data/whatsapp';

const {FiArrowUpRight} = FiIcons;

const stats = [
  {value: '12,000+', label: 'Members trained'},
  {value: '45+', label: 'Classes every week'},
  {value: '18', label: 'Expert coaches'},
  {value: '4.9★', label: 'Member rating'},
];

function Stats() {
  return (
    <section className="stats-section" id="stats">
      <div className="stats-strip">
        <p>Train with intention.<br />Get stronger for everything outside the gym.</p>
        <a href={waLink('I would love to discover the Forge difference.')} target="_blank" rel="noreferrer">
          Discover the difference <SafeIcon icon={FiArrowUpRight} />
        </a>
      </div>
      <div className="stats-grid">
        {stats.map((s, i) => (
          <motion.div className="stat-cell" key={s.label}
            initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}}
            viewport={{once: true}} transition={{delay: i * 0.1, duration: 0.5}}>
            <div className="stat-content">
              <strong>{s.value}</strong>
              <span>{s.label}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
